import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7f4aea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "page-title-text-area" }
const _hoisted_4 = {
  key: 0,
  class: "badge"
}
const _hoisted_5 = {
  key: 0,
  class: "alert alert-primary alert-sm page-alert supervise-alert"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-primary alert-sm page-alert supervise-alert"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "nav nav-pills" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "personalTab",
    class: "nav-link active",
    "data-bs-toggle": "tab",
    "data-bs-target": "#personalPane",
    role: "tab",
    "aria-controls": "personalPane",
    "aria-selected": "false"
  }, " Personal ")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "researchGroupsTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#researchGroupsPane",
  role: "tab",
  "aria-controls": "researchGroupsPane",
  "aria-selected": "true"
}, " Trees ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "profilesTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#profilesPane",
  role: "tab",
  "aria-controls": "profilesPane",
  "aria-selected": "true"
}, " Profiles ", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "familyGroupsTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#familyGroupsPane",
  role: "tab",
  "aria-controls": "familyGroupsPane",
  "aria-selected": "true"
}, " Groups ", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "securityTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#securityPane",
  role: "tab",
  "aria-controls": "securityPane",
  "aria-selected": "true"
}, " Security ", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "subscriptionTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#subscriptionPane",
  role: "tab",
  "aria-controls": "subscriptionPane",
  "aria-selected": "true"
}, " Subscription ", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "supervisorTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#supervisorPane",
  role: "tab",
  "aria-controls": "supervisorPane",
  "aria-selected": "true"
}, " Parent account ", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "adminTab",
  class: "nav-link admin",
  "data-bs-toggle": "tab",
  "data-bs-target": "#adminPane",
  role: "tab",
  "aria-controls": "adminPane",
  "aria-selected": "true"
}, " Admin ", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  class: "tab-content content-area"
}
const _hoisted_32 = {
  id: "personalPane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelledby": "personalTab",
  tabindex: "0"
}
const _hoisted_33 = {
  key: 0,
  class: "profile-section"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Contact info", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " We use this to contact you about your account. You can also choose to share this information with others. ", -1))
const _hoisted_36 = { class: "contact-summary" }
const _hoisted_37 = { class: "name" }
const _hoisted_38 = { class: "profile-section" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Public profile", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " A public profile contains general information about yourself that you would like to share with others. It may include your hometown, genealogical interests, or other details. ", -1))
const _hoisted_41 = {
  key: 1,
  class: "profile-section"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Personal profile", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " A personal profile determines what information about you is included in a family tree. Your personal profile may include life events, photos, or other information typically shared only with people you know. ", -1))
const _hoisted_44 = {
  key: 0,
  type: "button",
  class: "btn btn-danger mt-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#resetUserModal"
}
const _hoisted_45 = {
  key: 0,
  id: "researchGroupsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "researchGroupsTab",
  tabindex: "0"
}
const _hoisted_46 = {
  key: 1,
  id: "profilesPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "profilesTab",
  tabindex: "0"
}
const _hoisted_47 = {
  key: 2,
  id: "familyGroupsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "familyGroupsTab",
  tabindex: "0"
}
const _hoisted_48 = {
  key: 3,
  id: "securityPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "securityTab",
  tabindex: "0"
}
const _hoisted_49 = {
  key: 4,
  id: "subscriptionPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "subscriptionTab",
  tabindex: "0"
}
const _hoisted_50 = {
  id: "supervisorPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "supervisorTab",
  tabindex: "0"
}
const _hoisted_51 = {
  id: "adminPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "adminTab",
  tabindex: "0"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "This will:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Delete any trees you own"),
    /*#__PURE__*/_createElementVNode("li", null, "Delete any groups you own"),
    /*#__PURE__*/_createElementVNode("li", null, "Leave any groups you've joined"),
    /*#__PURE__*/_createElementVNode("li", null, "Delete all data in your profile")
  ])
], -1))

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { usePageTitle } from '@/util/AppUtil'
import { useInitialTabRouting } from '@/util/InitialTabRouting'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { DataGroup, ItemPermissions } from '@/gp/GroupAdminModel'
import { AsyncUtil } from '@/util/AsyncUtil'
import { LoadMode } from '@/util/AsyncData'
import { UserPrivilege, useTokenManager } from '@/auth/TokenManager'
import { LockIcon, MailIcon } from '@zhuowenli/vue-feather-icons'
import SecurityInfo from '@/account/SecurityInfo.vue'
import ContactInfo from '@/account/ContactInfo.vue'
import SubscriptionInfo from '@/account/SubscriptionInfo.vue'
import AccountAdmin from '@/account/AccountAdmin.vue'
import Modal from '@/util/Modal.vue'
import ResultIndicator from '@/util/ResultIndicator.vue'
import UserSwitchModal from '@/manage/users/UserSwitchModal.vue'
import ResearchGroupList from '@/manage/researchgroups/ResearchGroupList.vue'
import ProfileList from '@/manage/profiles/ProfileList.vue'
import FamilyGroupList from '@/manage/familygroups/FamilyGroupList.vue'
import SupervisionEditor from '@/manage/users/UserSupervisionEditor.vue'
import PrivacyLevelIndicator from './PrivacyLevelIndicator.vue'
import ContactInfoModal from './ContactInfoModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountPage',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const isUserProfileVisibleRef = ref(false)
const userProfileGroupRef = ref<DataGroup>()
const userPersonIdRef = ref<string>()
const userPrivilegesRef = ref<UserPrivilege[]>()

const resetSuccessAlertRef = ref<InstanceType<typeof ResultIndicator>>()
const contactInfoModalRef = ref<InstanceType<typeof ContactInfoModal>>()
const userSwitchModalRef = ref<InstanceType<typeof UserSwitchModal>>()
const resetUserModalRef = ref<InstanceType<typeof Modal>>()

const route = useRoute()
const userStore = useUserStore()
const viewPersonStore = useViewPersonStore()
const dataGroupStore = useDataGroupStore()
const personStore = usePersonStore()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId!)
const permissionsRef = computed(() => userStore.getAsyncPermissions(userIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const isOwnerRef = computed(() => (permissionsRef.value & ItemPermissions.Owner) > 0)
const canReadAllUsersRef = computed(() => tokenManager.current.hasPrivilege(UserPrivilege.ReadAllUsers))
const showSecurityRef = computed(() => isOwnerRef.value || canReadAllUsersRef.value)
const showResearchGroupsRef = computed(() => !isOwnerRef.value)
const showManagedProfilesRef = computed(() => !isOwnerRef.value)
const showFamilyGroupsRef = computed(() => !isOwnerRef.value)
const showSubscriptionRef = computed(() => isOwnerRef.value || canReadAllUsersRef.value)
const showAdminRef = computed(() => tokenManager.current.hasPrivilege(UserPrivilege.ReadAllUsers))
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const isUserAdminRef = computed(() => permissionsRef.value && (permissionsRef.value & ItemPermissions.Modify) > 0)
const isUserSupervisorRef = computed(() => !isOwnerRef.value && isUserAdminRef.value)
const isSupervisedRef = computed(() => isOwnerRef.value && permissionsRef.value && !isUserAdminRef.value)
const showSupervisorRef = computed(() => isOwnerRef.value || isUserSupervisorRef.value)
const isDemoUserRef = computed(() => userPrivilegesRef.value?.includes(UserPrivilege.DemoUser))
const canResetUserRef = computed(() =>
  (userRef.value?.isTestUser || isDemoUserRef.value) &&
  (isOwnerRef.value || tokenManager.current.hasPrivilege(UserPrivilege.ManageUsers)))

const titleRef = usePageTitle("Account", () => isOwnerRef.value ? undefined : userRef.value?.displayName, true)
useInitialTabRouting('personalTab')

watch(userRef, async () => {
  isUserProfileVisibleRef.value = false
  userProfileGroupRef.value = undefined
  userPersonIdRef.value = undefined
  userPrivilegesRef.value = undefined

  if (userRef.value) {
    if (tokenManager.current.hasPrivilege(UserPrivilege.ReadAllDataGroups)) {
      isUserProfileVisibleRef.value = true      
    }
    else {
      const selfViewGroups = await dataGroupStore.getViewGroupsForUserAsync()
      isUserProfileVisibleRef.value = selfViewGroups.some(g => g.id == userRef.value?.profileDataGroupId)
    }

    userPrivilegesRef.value = isOwnerRef.value
      ? tokenManager.current.userPrivileges
      : await userStore.getPrivilegesAsync(userIdRef.value)

    if (isUserProfileVisibleRef.value) {
      userProfileGroupRef.value = await dataGroupStore.getAsyncGroup(userRef.value.profileDataGroupId, LoadMode.EnsureLoaded)!.whenLoadCompleted
      userPersonIdRef.value = userProfileGroupRef.value?.startItemId

      if (userProfileGroupRef.value) {        
        const vp = await viewPersonStore.getAsyncPerson(userPersonIdRef.value, LoadMode.EnsureLoaded)!.whenLoadCompleted
        await Promise.all([
          personStore.getPersonListAsync(vp?.matchIds ?? []),
          dataGroupStore.getGroupListAsync(vp?.groupIds ?? []),
        ])
      }
    }
  }
}, { immediate: true })

function editContactInfo() {
  contactInfoModalRef.value?.open(userIdRef.value)
}

function onSwitchToUser(userId: string) {
  userSwitchModalRef.value?.open(userId)
}

async function resetUser() {
  await AsyncUtil.atLeast(500, userStore.resetAsync(userIdRef.value!))

  await resetUserModalRef.value?.close()
  resetSuccessAlertRef.value?.show()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, [
          _createTextVNode(_toDisplayString(_unref(titleRef)) + " ", 1),
          (isDemoUserRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "DEMO"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(ResultIndicator, {
      ref_key: "resetSuccessAlertRef",
      ref: resetSuccessAlertRef,
      "alert-type": "success"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" This account has been reset. ")
      ]),
      _: 1
    }, 512),
    (isUserSupervisorRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_unref(LockIcon)),
            _createTextVNode(" You manage this child account. ")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onSwitchToUser(userIdRef.value)))
          }, " Switch to this user ")
        ]))
      : _createCommentVNode("", true),
    (isSupervisedRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createVNode(_unref(LockIcon)),
            _createTextVNode(" Your account is managed by a parent. ")
          ])
        ]))
      : _createCommentVNode("", true),
    (!isUserAdminRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_8, [
        _hoisted_9,
        (showResearchGroupsRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true),
        (showManagedProfilesRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, _hoisted_15))
          : _createCommentVNode("", true),
        (showFamilyGroupsRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_16, _hoisted_18))
          : _createCommentVNode("", true),
        (showSecurityRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_19, _hoisted_21))
          : _createCommentVNode("", true),
        (showSubscriptionRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_22, _hoisted_24))
          : _createCommentVNode("", true),
        (showSupervisorRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_25, _hoisted_27))
          : _createCommentVNode("", true),
        (showAdminRef.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_28, _hoisted_30))
          : _createCommentVNode("", true)
      ])
    ]),
    (userRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("section", _hoisted_32, [
            (isOwnerRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(userRef.value.displayName), 1),
                    _createVNode(PrivacyLevelIndicator, {
                      value: userRef.value.namePrivacy
                    }, null, 8, ["value"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(MailIcon)),
                      _createTextVNode(" " + _toDisplayString(userRef.value.email), 1)
                    ]),
                    _createVNode(PrivacyLevelIndicator, {
                      value: userRef.value.emailPrivacy
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: editContactInfo
                    }, " Edit contact info ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _hoisted_40,
              (userRef.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: userRef.value.pageUrl,
                    class: "btn btn-outline-primary btn-sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" View public profile ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            (isUserProfileVisibleRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _hoisted_43,
                  (userProfileGroupRef.value)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: userProfileGroupRef.value.pageUrl,
                        class: "btn btn-outline-primary btn-sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" View personal profile ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (canResetUserRef.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_44, " Reset account "))
                : _createCommentVNode("", true)
            ])
          ]),
          (showResearchGroupsRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
                _createVNode(ResearchGroupList, { "user-id": userIdRef.value }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true),
          (showManagedProfilesRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                _createVNode(ProfileList, { "user-id": userIdRef.value }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true),
          (showFamilyGroupsRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_47, [
                _createVNode(FamilyGroupList, { "user-id": userIdRef.value }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true),
          (showSecurityRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                _createVNode(SecurityInfo, { "user-id": userIdRef.value }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true),
          (showSubscriptionRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                _createVNode(SubscriptionInfo, { "user-id": userIdRef.value }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_50, [
            _createVNode(SupervisionEditor, {
              "user-id": props.userId
            }, null, 8, ["user-id"])
          ]),
          _createElementVNode("section", _hoisted_51, [
            _createVNode(AccountAdmin, { "user-id": userIdRef.value }, null, 8, ["user-id"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ContactInfoModal, {
      ref_key: "contactInfoModalRef",
      ref: contactInfoModalRef
    }, null, 512),
    _createVNode(UserSwitchModal, {
      ref_key: "userSwitchModalRef",
      ref: userSwitchModalRef
    }, null, 512),
    _createVNode(Modal, {
      id: "resetUserModal",
      ref_key: "resetUserModalRef",
      ref: resetUserModalRef,
      "ok-style": "danger",
      onOk: resetUser
    }, {
      title: _withCtx(() => [
        _createTextVNode("Reset your account?")
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Reset now")
      ]),
      busyText: _withCtx(() => [
        _createTextVNode("Resetting...")
      ]),
      default: _withCtx(() => [
        _hoisted_52
      ]),
      _: 1
    }, 512)
  ]))
}
}

})